import { createTheme } from '@mui/material/styles'

const customTheme = createTheme({
  palette: {
    primary: {
      main: '#5c8908',
      light: '#8db941',
      dark: '#2c5c00',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#37465b',
      light: '#627188',
      dark: '#0e1f32',
      contrastText: '#ffffff',
    },
    thertiary: {
      main: '#E5E5E5',
      contrastText: '#221F1F',
    },
    default: {
      main: '#37465b',
      light: '#627188',
      dark: '#0e1f32',
      contrastText: '#ffffff',
    },
    other: {
      white: '#ffffff',
      dark: '#221F1F',
      darker: '#707070',
      blue: '#4390D4',
      grey: '#ECECEC',
      lightGrey: '#BEBEBE',
      darkGrey: '#ABABAB',      
    },
    shadows: {
      main: '0px 0px 78px #1D1D1D1A',
    },
  }, 
  font: {
    primary: '"Roboto", sans-serif',
  },
  spacing: (factor) => `${0.5 * factor}vw`,
})

export default customTheme
